export const ACCESS_TOKEN_KEY = "access_token";
export const ACCESS_TOKEN_EXP = "access_token_exp";
export const ACCESS_USER_KEY = "user_access";

export const FCM_TOKEN = "user_fcm_token";
